import CommonModal from "@/components/ui/CommonModal";
import {
  FlowFormPanelLayout,
  FormSectionLayout,
} from "@/components/ui/FlowFormPanel/FlowFormPanel";
import { useModal } from "@/hooks/modals/useModal";
import { Form } from "antd";
import type { PurchaseContractFormValues } from "../type";
import { PurchaseContractForm } from "./PurchaseContractForm";

export function PurchaseContractModal() {
  const { open, props, closeModal } = useModal("PURCHASE_CONTRACT");

  const [form] = Form.useForm<PurchaseContractFormValues>();

  return (
    <CommonModal
      width={1100}
      title="合同审查申请"
      open={open}
      onCancel={closeModal}
      footer={null}
    >
      <FlowFormPanelLayout
        leftPanel={
          <FormSectionLayout
            body={<PurchaseContractForm form={form} />}
            footer={null}
          />
        }
        rightPanel={null}
      />
    </CommonModal>
  );
}
